import React, { useState } from 'react'

// Set to true to re-enable the cookie consent banner
const COOKIE_CONSENT_ENABLED = false

export default function CookieConsent() {
  const [visible, setVisible] = useState(() => COOKIE_CONSENT_ENABLED && !localStorage.getItem('skilflow_cookie_consent'))

  if (!visible) return null

  const handle = (accepted: boolean) => {
    localStorage.setItem('skilflow_cookie_consent', accepted ? 'accepted' : 'declined')
    setVisible(false)
    if (accepted) {
      window.dataLayer = window.dataLayer || [];
      (window.dataLayer as any[]).push({ event: 'cookie_consent_granted' })
    }
  }

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000,
      background: '#111827', borderTop: '1px solid #1e2d45',
      padding: '14px 24px', display: 'flex', alignItems: 'center', gap: 16,
      flexWrap: 'wrap',
    }}>
      <div style={{ flex: 1, minWidth: 240, fontSize: 13, color: '#94a3b8', lineHeight: 1.5 }}>
        We use cookies to measure how people use Skilflow so we can improve it. No advertising cookies, ever.{' '}
        <a href="/privacy" style={{ color: '#a78bfa', textDecoration: 'none' }}>Privacy policy</a>
      </div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button onClick={() => handle(false)} style={{
          padding: '7px 16px', background: 'transparent', border: '1px solid #2d3f5c',
          borderRadius: 8, color: '#94a3b8', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
        }}>Decline</button>
        <button onClick={() => handle(true)} className="btn-primary" style={{ padding: '7px 16px', fontSize: 12 }}>
          Accept
        </button>
      </div>
    </div>
  )
}

declare global {
  interface Window { dataLayer: any[] }
}
